import { Row, Col, Container, Image } from 'react-bootstrap';
import TopMenu from '../components/TopMenu';
import BottomMenu from '../components/BottomMenu';
import httlogo from '../images/httcrop.png';

import isuzulogo from '../images/isuzulogo.jpg';
import mcneiluslogo from '../images/mcneiluslogo.jpg';
import peterbiltlogo from '../images/peterbiltlogo.jpg';

function CustomTruck() {
    return (
        <div>
            <Image
                src={httlogo}
                alt="background"
                style={{
                    top: 0,
                    left: window.innerWidth < 768 ? '110px' : '30px',
                    height: '75px',
                }}
            />
            <TopMenu />
            <h2 className='htitleb text-center'>Customize Your Truck</h2>
            <hr />
            <Container>
                <p>
                    The sales department at HT&T Truck Center has years of experience building the
                    right trucks to meet the demands of Hawaii. We work with truck and body manufacturers
                    to ensure that we optimize the best balance between price, operating costs and resale value.
                    Our sales team has the expertise to handle your trade equipment needs, whether you are looking for
                    a medium-duty dry van to a tractor to a refuse truck. For over 60 years, HT&T Truck Center has built
                    a reputation as the industry leader for transportation solutions in the following areas: </p>
                <Row className='justify-content-center'>
                    <Col md={6}>
                        <Row className='justify-content-center'>
                            <Col md={4}>
                                <ul>
                                    <li>Owner Operator</li>
                                    <li>Bulk/Regional Haul</li>
                                    <li>Heavy Haul</li>
                                    <li>Government/Utility</li>
                                    <li>Emergency</li>
                                </ul>
                            </Col>
                            <Col md={4}>
                                <ul>
                                    <li>Pickup and Delivery</li>
                                    <li>Beverage</li>
                                    <li>Construction</li>
                                    <li>Refuse</li>
                                    <li>Agriculture</li>
                                </ul>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={6}>
                        <h4 className='htitleb text-center'>Truck Sales Department</h4>
                        <Row className='justify-content-center'>
                            <Col>
                                <Row className='justify-content-center'>
                                    <hr />
                                    <Col md={6}>
                                        <h4 className='titleb text-center'>Hours</h4>
                                        <p className='text-center'>Monday - Friday (Closed Weekend) <br /> 7:00 AM - 4:00 PM</p>

                                    </Col>
                                    <Col md={6}>
                                        <h4 className='titleb text-center'>Contact</h4>
                                        <p className='text-center'> (808) 532-7501<br /> (Honolulu Office)</p>
                                    </Col>
                                </Row>
                            </Col>

                        </Row>
                    </Col>
                </Row>
                <hr />
                <br />
                <h2 className='htitleb text-center'>AUTHORIZED DEALERS FOR</h2>
                <Row>
                    <Col md={4} className="justify-content-center">
                        <div id="card-box">
                            <Image
                                src={peterbiltlogo}
                                width={'100%'}
                            />
                        </div>
                    </Col>
                    <Col md={4}>
                        <div id="card-box">
                            <Image
                                src={isuzulogo}
                                width={'100%'}
                            />
                        </div>
                    </Col>
                    <Col md={4}>
                        <div id="card-box">
                            <Image
                                src={mcneiluslogo}
                                width={'100%'}
                            />
                        </div>
                    </Col>
                </Row>
                <br />
            </Container>
            <BottomMenu />
        </div>
    );
}

export default CustomTruck;